module.exports = __webpack_public_path__ + "static/img/about-1.ef1200f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-1.png
// module id = InIZ
// module chunks = 1